import day from '../../utils/day';

export const providerAvailability = {
  providerTimezone: 'UTC',
  selectedDate: '2022-03-23',
  data: [
    {
      date: '2022-03-23',
      start: '08:30 PM',
      end: '9:00 PM',
    },
    {
      date: '2022-03-24',
      start: '09:00 AM',
      end: '09:30 AM',
    },
    {
      date: '2022-03-24',
      start: '09:30 AM',
      end: '10:00 AM',
    },
    {
      date: '2022-03-24',
      start: '10:00 AM',
      end: '10:30 AM',
    },
    {
      date: '2022-03-24',
      start: '10:30 AM',
      end: '11:00 AM',
    },
    {
      date: '2022-03-24',
      start: '11:00 AM',
      end: '11:30 AM',
    },
    {
      date: '2022-03-24',
      start: '11:30 AM',
      end: '12:00 PM',
    },
    {
      date: '2022-03-24',
      start: '12:00 PM',
      end: '12:30 PM',
    },
    {
      date: '2022-03-24',
      start: '01:00 PM',
      end: '01:30 PM',
    },
    {
      date: '2022-03-24',
      start: '01:30 PM',
      end: '02:00 PM',
    },
    {
      date: '2022-03-24',
      start: '02:00 PM',
      end: '02:30 PM',
    },
    {
      date: '2022-03-24',
      start: '02:30 PM',
      end: '03:00 PM',
    },
    {
      date: '2022-03-24',
      start: '03:00 PM',
      end: '03:30 PM',
    },
    {
      date: '2022-03-24',
      start: '04:30 PM',
      end: '05:00 PM',
    },
    {
      date: '2022-03-25',
      start: '01:00 AM',
      end: '01:30 AM',
    },
    {
      date: '2022-03-25',
      start: '01:30 AM',
      end: '02:00 AM',
    },
    {
      date: '2022-03-25',
      start: '02:00 AM',
      end: '02:30 AM',
    },
    {
      date: '2022-03-25',
      start: '02:30 AM',
      end: '03:00 AM',
    },
    {
      date: '2022-03-25',
      start: '05:00 AM',
      end: '05:30 AM',
    },
    {
      date: '2022-03-25',
      start: '05:30 AM',
      end: '06:00 AM',
    },
    {
      date: '2022-03-25',
      start: '06:00 AM',
      end: '06:30 AM',
    },
    {
      date: '2022-03-25',
      start: '08:30 AM',
      end: '09:00 AM',
    },
    {
      date: '2022-03-25',
      start: '09:00 AM',
      end: '09:30 AM',
    },
    {
      date: '2022-03-25',
      start: '09:30 AM',
      end: '10:00 AM',
    },
    {
      date: '2022-03-28',
      start: '11:00 AM',
      end: '11:30 AM',
    },
    {
      date: '2022-03-28',
      start: '11:30 AM',
      end: '12:00 PM',
    },
    {
      date: '2022-03-28',
      start: '12:00 PM',
      end: '12:30 PM',
    },
    {
      date: '2022-03-28',
      start: '12:30 PM',
      end: '01:00 PM',
    },
    {
      date: '2022-03-28',
      start: '01:00 PM',
      end: '01:30 PM',
    },
    {
      date: '2022-03-28',
      start: '01:30 PM',
      end: '02:00 PM',
    },
    {
      date: '2022-03-28',
      start: '02:30 PM',
      end: '03:00 PM',
    },
    {
      date: '2022-03-28',
      start: '03:00 PM',
      end: '03:30 PM',
    },
    {
      date: '2022-03-28',
      start: '03:30 PM',
      end: '04:00 PM',
    },
    {
      date: '2022-03-29',
      start: '11:00 AM',
      end: '11:30 AM',
    },
    {
      date: '2022-03-29',
      start: '11:30 AM',
      end: '12:00 PM',
    },
    {
      date: '2022-03-29',
      start: '12:00 PM',
      end: '12:30 PM',
    },
    {
      date: '2022-03-29',
      start: '12:30 PM',
      end: '01:00 PM',
    },
    {
      date: '2022-03-29',
      start: '01:00 PM',
      end: '01:30 PM',
    },
    {
      date: '2022-03-29',
      start: '01:30 PM',
      end: '02:00 PM',
    },
    {
      date: '2022-03-29',
      start: '02:00 PM',
      end: '02:30 PM',
    },
    {
      date: '2022-03-29',
      start: '02:30 PM',
      end: '03:00 PM',
    },
    {
      date: '2022-03-29',
      start: '03:00 PM',
      end: '03:30 PM',
    },
    {
      date: '2022-03-29',
      start: '03:30 PM',
      end: '04:00 PM',
    },
    {
      date: '2022-03-30',
      start: '11:00 AM',
      end: '11:30 AM',
    },
    {
      date: '2022-03-30',
      start: '11:30 AM',
      end: '12:00 PM',
    },
    {
      date: '2022-03-30',
      start: '12:00 PM',
      end: '12:30 PM',
    },
    {
      date: '2022-03-30',
      start: '12:30 PM',
      end: '01:00 PM',
    },
    {
      date: '2022-03-30',
      start: '01:00 PM',
      end: '01:30 PM',
    },
    {
      date: '2022-03-30',
      start: '01:30 PM',
      end: '02:00 PM',
    },
    {
      date: '2022-03-30',
      start: '02:00 PM',
      end: '02:30 PM',
    },
    {
      date: '2022-03-30',
      start: '03:30 PM',
      end: '04:00 PM',
    },
  ],
};
export const appointmentsAfter = [
  {
    id: 1224,
    startTime: '2021-08-08T10:00:00.000Z',
    endTime: '2021-08-08T10:15:00.000Z',
    active: true,
    notes: null,
    videoConfId: null,
    isChecked: false,
    createdAt: '2021-07-21T17:00:42.655Z',
    updatedAt: '2021-07-21T17:00:42.655Z',
    appointmentTypeId: 114,
    createdBy: 174,
    updatedBy: 174,
    appointment_participants: {
      patient: [
        {
          fullName: 'Freddie Mercury',
          participantType: 'patient',
          accountEnabled: true,
        },
      ],
      provider: [
        {
          fullName: 'Alice in Chains',
          participantType: 'provider',
          accountEnabled: true,
          providerId: 41,
        },
      ],
      provider_additional: [],
    },
    appointment_type: {
      name: 'therapy',
      duration: 20,
      setting: 'clinic',
      instruction: null,
    },
    raw: '02:20 AM - 02:40 AM',
  },
];

export const appointmentsBefore = [
  {
    id: 243,
    startTime: '2021-03-08T10:00:00.000Z',
    endTime: '2021-03-08T10:15:00.000Z',
    active: true,
    notes: null,
    videoConfId: null,
    isChecked: false,
    createdAt: '2021-07-13T22:20:00.000Z',
    updatedAt: '2021-07-13T22:20:00.000Z',
    appointmentTypeId: 72,
    createdBy: null,
    updatedBy: null,
    appointment_participants: {
      patient: [
        {
          fullName: 'Other Patient',
          participantType: 'patient',
          accountEnabled: true,
        },
        {
          fullName: 'Freddie Mercury',
          participantType: 'patient',
          accountEnabled: true,
        },
      ],
      provider: [
        {
          fullName: 'Mad Season',
          participantType: 'provider',
          accountEnabled: true,
          providerId: 43,
        },
      ],
      provider_additional: [
        {
          fullName: 'Ani Marti',
          participantType: 'provider_additional',
          accountEnabled: true,
          providerId: 23,
        },
        {
          fullName: 'Alice in Chains',
          participantType: 'provider_additional',
          accountEnabled: true,
          providerId: 41,
        },
      ],
    },
    appointment_type: {
      name: 'Clinic meeting',
      duration: 15,
      setting: 'clinic',
      instruction: "Fast discussion about patient's health.",
    },
    raw: '04:30 PM - 04:45 PM',
  },
];

export const appType = {
  data: [
    {
      id: 70,
      name: 'Virtual meeting',
      duration: 30,
      isActive: true,
      setting: 'virtual',
      instruction:
        "1. Schedule Your Procedure\n2. Complete Your Health History Forms Online\n3. Tell Us if You Have Special Needs, Like Disability or Language Translation\n4. Here is a general list of what you should bring to the hospital:\n\n- Cases for eyeglasses, contact lenses or hearing aids. All personal belongings will remain with your family member during the procedure.\n- A small bag with personal items only (toothbrush, toothpaste, floss, comb or brush, shaving kit, other toiletries), if you are staying overnight.\n- Cash or a credit card for your co-pays (depending on your insurance) and filling any post-surgical prescriptions.\nThe following documents, if applicable: Photo ID (such as a driver's license), insurance card(s), Medicare and/or Medicaid cards, a completed Living Will (if you have one).\n- Do not bring valuables.",
      createdBy: null,
      updatedBy: 1,
      inactive: false,
      selfScheduling: false,
      organizationName: 'Test Medical Center',
    },
  ],
};

export const availability = {
  providerTimezone: 'UTC',
  selectedDate: '2021-07-22',
  data: [
    {
      date: '2021-07-24',
      availability: [
        {
          start: '12:00 AM',
          end: '12:15 AM',
        },
        {
          start: '12:15 AM',
          end: '12:30 AM',
        },
        {
          start: '12:30 AM',
          end: '12:45 AM',
        },
        {
          start: '12:45 AM',
          end: '01:00 AM',
        },
      ],
    },
  ],
};

export const patientsAppointments = [
  {
    // ready to start
    id: 3356,
    startTime: day().tz('UTC').add(7, 'm'),
    endTime: '2022-04-15T10:30:00.000Z',
    active: true,
    notes: null,
    videoConfId: '62591aec4168bc3c2e526503',
    isChecked: false,
    isReminded: null,
    createdAt: '2022-04-15T07:12:43.032Z',
    updatedAt: '2022-04-15T07:12:44.677Z',
    appointmentTypeId: 70,
    createdBy: 174,
    updatedBy: 174,
    appointment_participants: {
      patient: [
        {
          fullName: 'Freddie Mercury',
          participantType: 'patient',
          accountEnabled: true,
        },
      ],
      provider: [
        {
          fullName: 'Alice in Chains',
          participantType: 'provider',
          accountEnabled: true,
          providerId: 41,
          prefix: 'Dr',
        },
      ],
      provider_additional: [],
    },
    appointment_type: {
      name: 'Virtual meeting',
      duration: 30,
      setting: 'virtual',
      instruction:
        "1. Schedule Your Procedure\n2. Complete Your Health History Forms Online\n3. Tell Us if You Have Special Needs, Like Disability or Language Translation\n4. Here is a general list of what you should bring to the hospital:\n\n- Cases for eyeglasses, contact lenses or hearing aids. All personal belongings will remain with your family member during the procedure.\n- A small bag with personal items only (toothbrush, toothpaste, floss, comb or brush, shaving kit, other toiletries), if you are staying overnight.\n- Cash or a credit card for your co-pays (depending on your insurance) and filling any post-surgical prescriptions.\nThe following documents, if applicable: Photo ID (such as a driver's license), insurance card(s), Medicare and/or Medicaid cards, a completed Living Will (if you have one).\n- Do not bring valuables.",
    },
    raw: '02:00 PM - 02:30 PM',
  },
  {
    // complete
    id: 3357,
    startTime: day().tz('UTC').subtract(180, 'm'),
    endTime: '2022-04-15T10:15:00.000Z',
    active: true,
    notes: null,
    videoConfId: null,
    isChecked: false,
    isReminded: null,
    createdAt: '2022-04-15T07:17:42.753Z',
    updatedAt: '2022-04-15T07:17:42.753Z',
    appointmentTypeId: 72,
    createdBy: 174,
    updatedBy: 174,
    appointment_participants: {
      patient: [
        {
          fullName: 'Freddie Mercury',
          participantType: 'patient',
          accountEnabled: true,
        },
      ],
      provider: [
        {
          accountEnabled: true,
          fullName: 'Clara Monte',
          participantType: 'provider_additional',
          providerId: 604,
          prefix: 'Dr',
        },
      ],
      provider_additional: [],
    },
    appointment_type: {
      name: 'Clinic meeting',
      duration: 15,
      setting: 'clinic',
      instruction: "Fast discussion about patient's health.",
    },
    raw: '02:00 PM - 02:15 PM',
  },
  {
    // begins later
    id: 3365,
    startTime: day().tz('UTC').add(20, 'm'),
    endTime: '2022-04-19T23:20:52.196Z',
    active: true,
    notes: null,
    videoConfId: '625e91f96ed5f517fb239956',
    isChecked: false,
    isReminded: null,
    createdAt: '2022-04-19T10:42:00.719Z',
    updatedAt: '2022-04-19T10:42:01.877Z',
    appointmentTypeId: 70,
    createdBy: 248,
    updatedBy: 248,
    appointment_participants: {
      patient: [
        {
          fullName: 'Freddie Mercury',
          participantType: 'patient',
          accountEnabled: true,
        },
      ],
      provider: [
        {
          accountEnabled: true,
          fullName: 'Duna Sola',
          participantType: 'provider_additional',
          providerId: 717,
          prefix: 'Dr',
        },
      ],
      provider_additional: [],
    },
    appointment_type: {
      name: 'Virtual meeting',
      duration: 30,
      setting: 'virtual',
      instruction:
        "1. Schedule Your Procedure\n2. Complete Your Health History Forms Online\n3. Tell Us if You Have Special Needs, Like Disability or Language Translation\n4. Here is a general list of what you should bring to the hospital:\n\n- Cases for eyeglasses, contact lenses or hearing aids. All personal belongings will remain with your family member during the procedure.\n- A small bag with personal items only (toothbrush, toothpaste, floss, comb or brush, shaving kit, other toiletries), if you are staying overnight.\n- Cash or a credit card for your co-pays (depending on your insurance) and filling any post-surgical prescriptions.\nThe following documents, if applicable: Photo ID (such as a driver's license), insurance card(s), Medicare and/or Medicaid cards, a completed Living Will (if you have one).\n- Do not bring valuables.",
    },
    raw: '02:50 AM - 03:20 AM',
  },
  {
    // in progress virtual
    id: 3366,
    startTime: day().tz('UTC').subtract(5, 'm'),
    endTime: '2022-04-20T01:10:39.671Z',
    active: true,
    notes: null,
    videoConfId: null,
    isChecked: false,
    isReminded: null,
    createdAt: '2022-04-19T12:47:57.991Z',
    updatedAt: '2022-04-19T12:47:57.991Z',
    appointmentTypeId: 114,
    createdBy: 248,
    updatedBy: 248,
    appointment_participants: {
      patient: [
        {
          fullName: 'Freddie Mercury',
          participantType: 'patient',
          accountEnabled: true,
        },
      ],
      provider: [
        {
          accountEnabled: true,
          fullName: 'Hovh Draskhanakerttsy',
          participantType: 'provider_additional',
          providerId: 1175,
          prefix: 'Dr',
        },
      ],
      provider_additional: [],
    },
    appointment_type: {
      name: 'Virtual meeting',
      duration: 30,
      setting: 'virtual',
      instruction: null,
    },
    raw: '04:50 AM - 05:10 AM',
  },
  {
    // checked in
    id: 3369,
    startTime: day().tz('UTC').subtract(5, 'm'),
    endTime: '2022-04-19T13:08:00.192Z',
    active: true,
    notes: null,
    videoConfId: null,
    isChecked: false,
    isReminded: null,
    createdAt: '2022-04-19T12:53:05.769Z',
    updatedAt: '2022-04-19T12:53:05.769Z',
    appointmentTypeId: 72,
    createdBy: 248,
    updatedBy: 248,
    appointment_participants: {
      patient: [
        {
          fullName: 'Freddie Mercury',
          participantType: 'patient',
          accountEnabled: true,
        },
      ],
      provider: [
        {
          accountEnabled: true,
          fullName: 'Movses Khorenatsy',
          participantType: 'provider_additional',
          providerId: 1176,
          prefix: 'Dr',
        },
      ],
      provider_additional: [],
    },
    appointment_type: {
      name: 'Clinic meeting',
      duration: 15,
      setting: 'clinic',
      instruction: "Fast discussion about patient's health.",
    },
    raw: '04:53 PM - 05:08 PM',
  },
];

export const appTypes = [
  {
    id: 71,
    name: 'APPOINT',
    duration: 15,
    isActive: true,
    setting: 'virtual',
    instruction: 'testing.',
    createdBy: null,
    updatedBy: 138,
    inactive: false,
    selfScheduling: false,
    organizationName: 'Armenia Medical Center',
  },
  {
    id: 77,
    name: 'test',
    duration: 44,
    isActive: true,
    setting: 'clinic',
    instruction: 'test',
    createdBy: null,
    updatedBy: 138,
    inactive: false,
    selfScheduling: false,
    organizationName: 'Armenia Medical Center',
  },
  {
    id: 111,
    name: 'Therapy',
    duration: 20,
    isActive: true,
    setting: 'clinic',
    instruction: '',
    createdBy: 1,
    updatedBy: 187,
    inactive: false,
    selfScheduling: false,
    organizationName: 'Armenia Medical Center',
  },
];

export const appointmentsData = [
  {
    id: 4917,
    startTime: '2022-06-28T05:50:00.000Z',
    endTime: '2022-06-28T06:20:00.000Z',
    active: true,
    notes: null,
    videoConfId: null,
    isChecked: false,
    isReminded: 1,
    createdAt: '2022-06-27T05:39:05.235Z',
    updatedAt: '2022-06-27T05:41:11.077Z',
    appointmentTypeId: 91,
    createdBy: 11360,
    updatedBy: 11360,
    appointment_participants: {
      patient: [
        {
          fullName: 'gopi270622063715 Ekambaram',
          participantType: 'patient',
          accountEnabled: true,
        },
      ],
      provider: [
        {
          fullName: 'gayathri270622043415 Gopalan',
          participantType: 'provider',
          accountEnabled: true,
          providerId: 1600,
        },
      ],
      provider_additional: [],
    },
    appointment_type: {
      name: 'New Type',
      duration: 30,
      setting: 'clinic',
      instruction: '3',
    },
    raw: '05:50 AM - 06:20 AM',
  },
  {
    id: 3660,
    startTime: day().tz('UTC').add(1, 'minutes'),
    endTime: day().tz('UTC').add(5, 'minutes'),
    active: true,
    notes: null,
    videoConfId: '62b94d051b9586001d0cb241',
    isChecked: false,
    isReminded: null,
    createdAt: '2022-06-27T06:24:04.141Z',
    updatedAt: '2022-06-27T06:24:05.306Z',
    appointmentTypeId: 71,
    createdBy: 11364,
    updatedBy: 11364,
    cancelReasons: [
      { id: 1, name: 'No show' },
      { id: 2, name: 'Late cancellation' },
      { id: 3, name: 'Provider conflict' },
      { id: 4, name: 'Patient conflict' },
    ],
    appointment_participants: {
      patient: [
        {
          fullName: 'Alice Cooper',
          participantType: 'patient',
          accountEnabled: true,
        },
      ],
      provider: [
        {
          fullName: 'Alice in Chains',
          participantType: 'provider',
          accountEnabled: true,
          providerId: 41,
        },
      ],
      provider_additional: [],
    },
    appointment_type: {
      name: 'APPOINT',
      duration: 15,
      setting: 'virtual',
      instruction: 'testing.',
    },
    raw: '06:30 AM - 06:45 AM',
  },
];

export const appointmentData = {
  id: 3660,
  startTime: day().tz('UTC').add(1, 'minutes'),
  endTime: day().tz('UTC').add(5, 'minutes'),
  notes: 'notes',
  videoConfId: '62bd71bff3028a00e13e9ece',
  isChecked: false,
  isReminded: null,
  appointmentTypeId: 71,
  createdBy: 248,
  updatedBy: 248,
  cancelReasons: [
    { id: 1, name: 'No show' },
    { id: 2, name: 'Late cancellation' },
    { id: 3, name: 'Provider conflict' },
    { id: 4, name: 'Patient conflict' },
  ],
  patient: [
    {
      id: 6543,
      userId: 4031,
      fullName: 'Alice Cooper',
      active: true,
      providerUser: [],
      patient: {
        patientId: 3220,
      },
    },
  ],
  provider: [
    {
      id: 457,
      userId: 248,
      fullName: 'Alice in Chains',
      active: true,
      providerUser: [
        {
          providerId: 41,
        },
      ],
      patient: null,
    },
  ],
  provider_additional: [
    {
      id: 15,
      userId: 32,
      fullName: 'Ani Marti',
      active: true,
      providerUser: [
        {
          providerId: 55,
        },
      ],
      patient: null,
    },
  ],
  appointmentType: 'APPOINT, virtual (15)',
  organizationId: 8,
  instruction: 'testing.',
};
